import { getMonthsAgo } from "helpers/dates";
import { DateObject } from "react-multi-date-picker";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";

export const DefaultInputFilter = { label: "همه نهاده ها", value: 0 };
export const DefaultConcentrateFilter = { label: "کنسانتره", value: null };
export const DefaultProvinceFilter = { label: "همه استان ها", value: 0 };
export const DefaultUnionFilter = { label: "انتخاب اتحادیه", value: 0 };
export const DefaultCompanyFilter = { label: "انتخاب شرکت", value: 0 };
export const DefaultFilterType = { label: "همه استان ها", value: -1 };
export const SelfFilterType = { label: "اتحادیه مرکزی (ادمین)", value: -2 };
export const DefaultMonthFilter = { label: "همه ماه ها", value: 0 };

export const DateRadio = {
  LastMonth: "last-month-inputs",
  LastThreeMonths: "last-three-months-inputs",
  CustomDate: "arbitary-time-range",
};

export const DefaultDateFilter = {
  from: new DateObject(getMonthsAgo(1))
    .convert(gregorian, gregorian_en)
    .toUTC()
    .format("YYYY-MM-DD"),
  to: new DateObject(new Date())
    .convert(gregorian, gregorian_en)
    .toUTC()
    .format("YYYY-MM-DD"),
};

export const DefaultFilterState = {
  pageOffset: 1,
  fromDate: DefaultDateFilter.from,
  toDate: DefaultDateFilter.to,
  selectedInput: DefaultInputFilter,
  selectedProvince: DefaultProvinceFilter,
  selectedFilterType: DefaultFilterType,
  selectedUnion: DefaultUnionFilter,
  selectedCompany: DefaultCompanyFilter,
  pickedDateFrom: DefaultDateFilter.from,
  pickedDateTo: DefaultDateFilter.to,
  selectedRadio: DateRadio.LastMonth,
  buysReportFilter: `?start_date=${DefaultDateFilter.from}&end_date=${DefaultDateFilter.to}&all_items=true&`,
  distsReportFilter: `?start_date=${DefaultDateFilter.from}&end_date=${DefaultDateFilter.to}&all_items=true&`,
  productsReportFilter: `?start_date=${DefaultDateFilter.from}&end_date=${DefaultDateFilter.to}&all_items=true&`,
  storesReportFilter: `?all_items=true&`,
};